(function () {
  function enableProductGalleryDots() {
    var gallery = document.querySelector('.template-product .product-gallery');
    if (!gallery) return;

    var slider = gallery.querySelector('.slick-slider');
    if (!slider || !window.jQuery) return;

    var $ = window.jQuery;

    // Already has dots? Then skip
    if ($(slider).find('.slick-dots').length) return;

    try {
      // Destroy existing slick
      if ($(slider).hasClass('slick-initialized')) {
        $(slider).slick('unslick');
      }

      // Re-init with dots enabled
      $(slider).slick({
        dots: true,
        arrows: true,
        infinite: false,
        adaptiveHeight: true
      });

    } catch (e) {
      console.warn('Slick dots init failed', e);
    }
  }

  document.addEventListener('DOMContentLoaded', enableProductGalleryDots);
  window.addEventListener('load', enableProductGalleryDots);
})();
